module.exports = __webpack_public_path__ + "img/ruou-chivas-12-750-ml.a7423e37.jpg";